export default 'en';



// WEBPACK FOOTER //
// ./src/shared/constants/default-locale.js